.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  max-width: 64.8rem;
}

.content {
  display: flex;
  flex-direction: column;
  width: 100%;
}
